// extracted by mini-css-extract-plugin
module.exports = {"name":"Sidebar_name__3hmJV","btnWrapper":"Sidebar_btnWrapper__2dwlw","wrapper":"Sidebar_wrapper__2XdfT","closeIcon":"Sidebar_closeIcon__HLZCS"};